import { Toggle as TogglePrimitive } from '@base-ui/react/toggle';
import type { ReactNode } from 'react';

import { badgeVariants } from '@/components/typography/Badge/Badge';
import { cn } from '@/lib/utils';

type ToggleBadgeProps = {
  className?: string;
  pressed?: boolean;
  disabled?: boolean;
  children: ReactNode;
  onPressedChange?: (pressed: boolean) => void;
};

const ToggleBadge = ({
  className,
  pressed = false,
  disabled = false,
  children,
  onPressedChange,
}: ToggleBadgeProps) => {
  return (
    <TogglePrimitive
      type="button"
      pressed={pressed}
      disabled={disabled}
      className={cn(
        badgeVariants({ color: pressed ? 'info' : 'default', disabled }),
        disabled ? 'cursor-not-allowed' : 'cursor-pointer',
        !disabled &&
          (pressed
            ? 'hover:border-aqua-500 hover:bg-aqua-200'
            : 'hover:border-gray-500 hover:bg-gray-200'),
        className,
      )}
      onPressedChange={onPressedChange}
    >
      {children}
    </TogglePrimitive>
  );
};

export default ToggleBadge;
